import React, { PureComponent } from 'react';

import { TEMPERATURES_MAP } from 'Pages/manageproduction/helpers/Constants';
import { ProductionRecordDetailFieldEnum as ProdRecordDetailFields } from 'Common/FieldEnum';
import * as ProdRecordHelpers from 'Pages/manageproduction/helpers/productionRecord';

import { GridInputCell } from './GridInputCell';

class TemperatureRow extends PureComponent {
  render() {
    const {
      isReadOnly,
      temperatures,
      onInputChange,
      [ProdRecordDetailFields.ArrayIndex]: index,
      ...detailProps
    } = this.props;
    const isIngredient = ProdRecordHelpers.isDetailIngredient(this.props);
    const inputs = [];
    const key = this.props[ProdRecordDetailFields.ReactKey];

    temperatures.forEach((temp, i) => {
      const temperature = TEMPERATURES_MAP[temp];

      let name = '';
      let length;

      if (temperature) {
        const fieldName = temperature.FieldName;
        name = fieldName;
        length = temperature.Length;
      }

      inputs.push(
        <GridInputCell
          inputProps={{
            name,
            maxLength: length,
            fluid: true,
            onChange: onInputChange,
            disabled: isReadOnly || !Boolean(name) || isIngredient,
            'data-index': index,
            value: detailProps[name],
          }}
          key={ProdRecordHelpers.createProdDetailKey(key, name || i)}
        />
      );
    });

    inputs.push(
      <GridInputCell
        inputProps={{
          name: ProdRecordDetailFields.Comments,
          className: 'align-left',
          fluid: true,
          onChange: onInputChange,
          disabled: isReadOnly || isIngredient,
          'data-index': index,
          value: detailProps[ProdRecordDetailFields.Comments] || '',
        }}
        key={ProdRecordHelpers.createProdDetailKey(
          key,
          ProdRecordDetailFields.Comments
        )}
      />
    );

    return inputs;
  }
}

export { TemperatureRow };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/TemperatureRow.js